import React, { useMemo } from "react";
import { Button, Col, Nav, Row } from "react-bootstrap";
import PropertySaleList from "containers/property/PropertySaleList";
import SaleBuyerSellerList from "containers/sale/SaleBuyerSellerList";
import { createElementIdFactory } from "utils/elementIds";

function SaleRelationsPanel({
  propertySaleFilter,
  isAuthenticated,
  user,
  propertySales,
  updateTableState,
  saveRecord,
  validateRelatedRecord,
  deleteRecord,
  removeHold,
  saleId,
  areaSum,
  getProperties,
  propertyidlist,
  userPermissions,
  onAddOwnerAsBuyerSeller,
  onRemoveVendorAsOwner,
  onToggleOwnerSearchDialog,
  buyerSellers,
  refreshDataSet,
  buyerSellerOptions,
}) {
  const createId = useMemo(() => createElementIdFactory("sale-detail-relations"), []);

  return (
    <>
      <PropertySaleList
        filter={propertySaleFilter}
        isAuthenticated={isAuthenticated}
        user={user}
        data={propertySales}
        updateTableState={updateTableState}
        saveRecord={saveRecord}
        validateRelatedRecord={validateRelatedRecord}
        deleteRecord={deleteRecord}
        removeHold={removeHold}
        saleid={saleId}
        controlType="table2"
        areaSum={areaSum}
        getProperties={getProperties}
        propertyidlist={propertyidlist || []}
        userPermissions={userPermissions}
      />

      <br />
      <Row>
        <Col sm={8} md={8} lg={8}>
          <Nav className="justify-content-start">
            <Nav.Item>
              <Button id={createId("add-buyers-vendors")} onClick={onAddOwnerAsBuyerSeller} type="button" size="sm" className="btn-teal">
                Add Buyers/Vendors From Property
              </Button>{" "}
            </Nav.Item>

            <Nav.Item>
              <Button id={createId("remove-vendors")} onClick={onRemoveVendorAsOwner} type="button" size="sm" className="btn-teal">
                Remove Vendors From Property
              </Button>{" "}
            </Nav.Item>
          </Nav>
        </Col>
        <Col>
          <Nav className="justify-content-end">
            <Nav.Item>
              <Button id={createId("search-add-buyers-vendors")} onClick={onToggleOwnerSearchDialog} type="button" size="sm" className="btn-teal">
                Search + Add Buyers/Vendors
              </Button>{" "}
            </Nav.Item>
          </Nav>
        </Col>
      </Row>
      <br />

      <SaleBuyerSellerList
        isAuthenticated={isAuthenticated}
        user={user}
        data={buyerSellers}
        updateTableState={updateTableState}
        saveRecord={saveRecord}
        deleteRecord={deleteRecord}
        refreshDataSet={refreshDataSet}
        controlType="table"
        validateRelatedRecord={validateRelatedRecord}
        buyerSellerOptions={buyerSellerOptions}
      />
    </>
  );
}

export default SaleRelationsPanel;
